import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ScheduleManagementIcon = React.forwardRef((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
      <path
        d="M 6 1 L 6 3 L 3 3 L 3 21 L 12.027344 21 C 12.107937 20.265008 12.388828 19.574224 12.826172 19 L 5 19 L 5 8 L 19 8 L 19 12.128906 C 19.784403 12.334528 20.477312 12.776509 21 13.371094 L 21 3 L 18 3 L 18 1 L 16 1 L 16 3 L 8 3 L 8 1 L 6 1 z
               M 7 10 L 7 12 L 9 12 L 9 10 L 7 10 z
               M 11 10 L 11 12 L 13 12 L 13 10 L 11 10 z
               M 15 10 L 15 12 L 17 12 L 17 10 L 15 10 z
               M 7 14 L 7 16 L 9 16 L 9 14 L 7 14 z
               M 11 14 L 11 16 L 13 16 L 13 14 L 11 14 z
               M 18 14 C 16.900002 14 16 14.900002 16 16 C 16 17.099998 16.900002 18 18 18 C 19.099998 18 20 17.099998 20 16 C 20 14.900002 19.099998 14 18 14 z
               M 18 19 C 17.010002 19 16.070701 19.210078 15.220703 19.580078 C 14.480705 19.900078 14 20.619688 14 21.429688 L 14 22 L 22 22 L 22 21.429688 C 22 20.619688 21.519295 19.900078 20.779297 19.580078 C 19.929299 19.210078 18.989998 19 18 19 z"
      />
    </SvgIcon>
  );
});

export default ScheduleManagementIcon;
